import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Chart from "react-apexcharts";

const iconMapping = {
  Desktop: "fas fa-desktop",
  Tablet: "fas fa-tablet-alt",
  Phone: "fas fa-mobile-alt",
};

const SalesRoundChart = ({ chartSeries, labels, sx }) => {
  const chartOptions = useChartOptions(labels);

  return (
    <Card sx={sx}>
      <CardContent>
        <Stack spacing={2}>
          <Chart
            height={345}
            options={chartOptions}
            series={chartSeries}
            type="donut"
            width="100%"
          />
          <Stack
            direction="row"
            spacing={4}
            sx={{ alignItems: "center", justifyContent: "center" }}
          >
            {chartSeries?.map((item, index) => {
              const label = labels[index];
              const iconClass = iconMapping[label];

              return (
                <Stack key={label} spacing={1} sx={{ alignItems: "center" }}>
                  {iconClass && (
                    <i className={iconClass} style={{ fontSize: 24 }}></i>
                  )}
                  <Typography variant="p" sx={{ textAlign: "center" }}>
                    {label}
                  </Typography>
                  <Typography color="text.secondary" variant="subtitle2">
                    {item}
                  </Typography>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SalesRoundChart;

const useChartOptions = (labels) => {
  const theme = useTheme();

  return {
    chart: { background: "transparent" },
    colors: [
      theme.palette.primary.main,
      theme.palette.success.main,
      theme.palette.warning.main,
    ],
    dataLabels: { enabled: false },
    labels,
    legend: { show: false },
    plotOptions: { pie: { expandOnClick: false } },
    states: {
      active: { filter: { type: "none" } },
      hover: { filter: { type: "none" } },
    },
    stroke: { width: 0 },
    theme: { mode: theme.palette.mode },
    tooltip: { fillSeriesColor: false },
  };
};
